module.exports = __webpack_public_path__ + "static/media/tim_cook.43a81a36.jpg";